import React, { useEffect, useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import { classNames } from "../../helpers/classNames";

const DatePicker = ({
  label,
  required,
  value,
  dateFormat = "DD/MM/YYYY",
  labelClasses,
  renge = false,
  onChange = () => {},
  showShortcuts = false,
  placeholder,
  errorType,
  errorText,
  className,
  resetTime = true,
  minDate,
  isDisabled = false,
}) => {
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    setDate({
      startDate: value?.startDate || null,
      endDate: value?.endDate || null,
    });
  }, [value]);

  function resetTimeHandler(date) {
    const resetDate = new Date(date);
    resetDate.setHours(0, 0, 0, 0);
    return resetDate;
  }

  const handleChange = (newDate) => {
    const { startDate, endDate } = newDate;
    if (resetTime && startDate && endDate) {
      const start = resetTimeHandler(startDate);
      const end = resetTimeHandler(endDate);
      setDate({ startDate: start, endDate: end });
      onChange({ startDate: start, endDate: end });
    } else {
      setDate(newDate);
      onChange(newDate);
    }
  };

  return (
    <div className="w-full relative space-y-1">
      {label && (
        <div
          className={classNames(
            "text-xs font-medium text-shades-07",
            labelClasses
          )}
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-0.5 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      <Datepicker
        displayFormat={dateFormat}
        primaryColor={"rose"}
        value={date}
        asSingle={!renge}
        useRange={renge}
        onChange={handleChange}
        showShortcuts={showShortcuts}
        popoverDirection="down"
        placeholder={placeholder || "Select date range"}
        containerClassName={"font-CanelaDeck relative"}
        minDate={minDate}
        disabled={isDisabled}
        inputClassName={classNames(
          "w-full h-10 p-2 text-sm font-CanelaDeck border border-shades-05/50 rounded-md focus:outline-none focus:border-shades-07 focus:ring-0 placeholder:text-shades-07",
          className
        )}
      />
      {errorType && errorType === "danger" && (
        <div className="text-xs text-red-600">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-600">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default DatePicker;
